import { Component, OnInit, ViewChild,ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../../services/account.service';
import { WindowRefService } from '../../../../services/window-ref.service';

import { MatDialog } from '@angular/material/dialog';
//import { PaytmVerifyDialogComponent } from './paytm-verify-dialog/paytm-verify-dialog.component';
//import { MerchantidDialogComponent } from './merchantid-dialog/merchantid-dialog.component';
import { EmailVerifyDialogComponent } from '../../../../shared/components/email-verify-dialog/email-verify-dialog.component';
//import { GatewayDialogComponent } from './gateway-dialog/gateway-dialog.component';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { PaytmService } from '../../../../services/paytm.service';
import { projectConstants } from '../../../../shared/constants/project-constants';
import { BankinfoCreationDialogComponent } from './bankinfo-creation/bankinfo-creation-dialog.component';
import { AdvancepayDialogComponent } from '../payment-settings/advancepay-dialog/advancepay-dialog.component';
import { DefaultProfileDialogComponent } from './default-profile-dialog/default-profile-dialog.component';


@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.css']
})
export class PaymentDetailsComponent implements OnInit {

  razorTextVal: string;
  payU_placeholder = 'Enter MechantId';
  response: any = {};
  reshtml: any;
  testhtml: string;
  Ischecked: boolean;
  api_error: any;
  api_success: string;
  merchantId: any;
  responseObj: any = {};
  paymentSettingDetails: any = {};
  payTmVerified: boolean;
  accountId: number;
  IsVisible = true;
  dataObj = {};
  enablePaytmBtn;
  payUTextVal = 'Set';
  toggleValue;
  taxPercentage = ' ';
  gstNumber = '';
  advancePayment;
  configData: any = {};
  paymentStatus: any = [];
  newDiscCodeChangedVal;
  showPayment;
  @ViewChild('consumer_appointmentbill', {static: false}) paytmview;
  paymentDetails: Object;
  @ViewChild('successmsg', {static: false}) successview
  @ViewChild('errormsg', {static: false}) errorview;
  constructor(private route: ActivatedRoute,
     private commonService: CommonfilterService,
     private accountService: AccountService,
     private dialog: MatDialog,
     private winRef: WindowRefService,
     private cdRef: ChangeDetectorRef,     
     private paytmService: PaytmService) { }

  ngOnInit() {
    this.route.parent.params.subscribe(params => {
      this.accountId = params['id'];
      this.getMerchantDetails();
      this.getPaymentDetails();

    });
    this.commonService.getConfigData()
    .subscribe(res => {
      this.configData = res;
      this.paymentStatus = this.configData.advancePayBankDetails;

    });
    this.accountService.getTaxDetails(this.accountId)
      .subscribe(res => {
        if (res === null) {
          this.taxPercentage = 'Nil';
          this.gstNumber = 'Nil';
        } else {
          console.log('res.........' + JSON.stringify(res));
          this.taxPercentage = res.taxPercentage;
          this.gstNumber = res.gstNumber;
        }

      });
    // this.accountService.getGSTNumber()
    // .subscribe( res => {
    //   this.gstNumber = res.toString();
    // });
  }
  getPaymentDetails() {
    this.accountService.getpaymentDetails(this.accountId)
      .subscribe(res => {
        this.paymentDetails = res;
        console.log(this.paymentDetails);
      });
  }
  newDiscCodeChanged(event) {
    this.newDiscCodeChangedVal = event;

   }
  getMerchantDetails() {
    this.api_error='';
    this.api_success='';
    this.accountService.paymentSettingDetails(this.accountId)
      .subscribe(res => {
        this.paymentSettingDetails = res;
        this.advancePayment = this.paymentSettingDetails.advancePaymentBank;
        this.payTmVerified = this.paymentSettingDetails.payTmVerified;
        if (this.paymentSettingDetails.payUMerchantId) {
          this.payUTextVal = 'Reset';
        }
        if (this.paymentSettingDetails.razorpayMerchantId) {
          this.razorTextVal = 'Reset';
        }
        this.payU_placeholder = this.paymentSettingDetails.payUMerchantId;

      });
  }
  // getAdvancePayment() {
  //   console.log(this.accountId);
  //   this.api_error='';
  //   this.api_success='';
  //   this.accountService.advanceSettingDetails(this.accountId)
  //     .subscribe(res => {
  //       this.advancePayment = res;
  //     });
  // }
  verify_paytm(payprofId) {
    this.accountService.testverifyPayTm(this.accountId,payprofId)
      .subscribe(
        (data) => {
          console.log(data);
          console.log('response from backend........' + data);
          console.log('response from backedn.......' + JSON.stringify(data));
          this.paytmService.initializePayment(data, projectConstants.PAYTM_URL, this);
          // const dialogRef = this.dialog.open(GatewayDialogComponent, {
          //   width: '100px',
          //   height: '100px',
          //   data: { 'data': data, 'form': 'paytmform' }
          // });

          // dialogRef.afterClosed().subscribe(result => {
          // });
        },
        // (error) => {
        //   this.api_error = error.error;
        // }
      );
  }
  transactionCompleted(response) {
    console.log(response);
    if(response.STATUS == 'TXN_SUCCESS'){
      const data={
        'paymentId':response.ORDERID,
        'orderId':response.ORDERID
  
      }
      this.accountService.updatePaytm(data,this.accountId)
      .subscribe(res=>{
        this.api_success='Paytm Verified Successfully';
      },error=>{
        this.api_error='Transaction failed';
      })
     
    } else {
      this.api_error='Transaction failed';
    }
    this.cdRef.detectChanges();
    this.getPaymentDetails();
    setTimeout(() => {
      this.api_error='';
    this.api_success='';
    this.cdRef.detectChanges();
    }, 3000)
  }
  closeloading(){
    console.log("close");
    this.api_error='Transaction cancelled';
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.api_error='';
      console.log("gfh");
      this.cdRef.detectChanges();
    }, 3000)
       
  }
  setAdvanceBank(){
    console.log(this.accountId);
    this.api_error='';
    this.api_success='';
    this.accountService.setadvanceSetting(this.advancePayment,this.accountId)
      .subscribe(res => {
        this.advancePayment = res;
      });
      this.showPayment = false;
  }
  showAdvanceBank(){
    this.showPayment = true;
  }
  // setMerchantId() {
  //   const dialogRef = this.dialog.open(MerchantidDialogComponent, {
  //     width: '900px',
  //     data: { 'accountId': this.accountId, 'paymentDetails': this.paymentSettingDetails, 'paymentMode': 'payU' }

  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.getMerchantDetails();

  //   });
  // }
  // setAdvancePay() {
  //   const dialogRef = this.dialog.open(AdvancepayDialogComponent, {
  //     width: '600px',
  //     data: { 'accountId': this.accountId, 'paymentDetails': this.paymentSettingDetails}

  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.getMerchantDetails();

  //   });
  // }
  // setRazorPayMerchantId() {
  //   const dialogRef = this.dialog.open(MerchantidDialogComponent, {
  //     width: '900px',
  //     data: { 'accountId': this.accountId, 'paymentDetails': this.paymentSettingDetails, 'paymentMode': 'razorPay' }

  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.getMerchantDetails();

  //   });
  // }
   setAdvancePay() {
    const dialogRef = this.dialog.open(AdvancepayDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'paymentDetails': this.paymentSettingDetails}

    });

    dialogRef.afterClosed().subscribe(result => {
      this.getMerchantDetails();

    });
  }
  setDefaultProfile() {
    const dialogRef = this.dialog.open(DefaultProfileDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'paymentDetails': this.paymentSettingDetails }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getMerchantDetails();
      this.getPaymentDetails();
    });
  }
  setbankDetails(bankid?,mode?) {
    const dialogRef = this.dialog.open(BankinfoCreationDialogComponent, {
      width: '900px',
      data: { 'accountId': this.accountId,
               'bankId' : bankid,
               'mode':mode ||''
            }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getPaymentDetails();

    });
  }
  // testPayU(payprofId?) {
  //   this.accountService.testPayU(this.accountId)
  //     .subscribe(
  //       (data) => {
  //          console.log(JSON.stringify(data));
  //         const dialogRef = this.dialog.open(GatewayDialogComponent, {
  //           width: '900px',
  //           height: 'auto',
  //           data: { 'data': data, 'form': 'payuform' }
  //         });

  //         dialogRef.afterClosed().subscribe(result => {


  //         });

  //       },
  //       (error) => {
  //         this.api_error = error.error;
  //       }
  //     );
  // }
  verify_RazorPay(payprofId?) {
    this.accountService.testverifyRazorPay(this.accountId,payprofId)
      .subscribe(
        (data) => {
          this.payWithRazor(data);
        },(error)=>{
          setTimeout(() => {
            this.api_error=error.error;
            setTimeout(() => {
              this.api_error='';
              console.log("gfh");
            }, 3000)
          }, 2000);
        }
      );
  }
  payWithRazor(dataObj) {
    console.log('data' + JSON.stringify(dataObj));
    const options: any = {
      key: dataObj.razorpayId,
      amount: dataObj.amount, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: 'Superadmin', // company name or product name
      description: dataObj.description,  // product description
      image: './assets/dist/img/avatar5.png', // company logo or product image
      order_id: dataObj.orderId, // order_id created by you in backend
      "prefill": {
        "name": dataObj.consumerName,
        "email": dataObj.ConsumerEmail,
        "contact": dataObj.consumerPhoneumber

      },
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#0c238a'
      }
    };
    options.handler = ((response, error) => {
      options.response = response;
      console.log(response);
      console.log(options);
      console.log('response...'+JSON.stringify(response));
      console.log('options...'+ JSON.stringify(options));
      this.callBackApiSuccess(response);

    });
    options.modal.ondismiss = (() => {
      // handle the case when user closes the form while transaction is in progress
      this.api_error='Transaction cancelled.';
      setTimeout(() => {
        this.api_error='';
      }, 3000)
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  emailUnverify() {

    const dialogRef = this.dialog.open(EmailVerifyDialogComponent, {
      width: '900px',
      height: 'auto',
      data: this.accountId
    });

    dialogRef.afterClosed().subscribe(result => {


    });
  }

  callBackApiSuccess(response): any {
    this.api_error='';
    this.api_success='';
 
    const data={
      'paymentId':response.razorpay_payment_id,
      'orderId':response.razorpay_order_id,
      'signature':response.razorpay_signature
    }
    this.accountService.updateRazorPay(data,this.accountId)
    .subscribe(res=>{
    const dataTosend: FormData = new FormData();
    dataTosend.append('razorpay_payment_id', response.razorpay_payment_id);
    dataTosend.append('razorpay_order_id',response.razorpay_order_id);
    dataTosend.append('razorpay_signature',response.razorpay_signature);
    
    this.accountService.verifyRazorPaySuccess(dataTosend)
      .subscribe(res => {
        if(res==='success'){
           this.api_success = "RazorPay Verified Successfully";
            this.getPaymentDetails();
        }
        setTimeout(() => {
          this.api_success='';
        }, 3000)
        
      },
        (error) => {
            this.api_error = error.error;
            setTimeout(() => {
              this.api_error='';
            }, 3000)
        }
        
      );
    });

  }
}
